module.exports = __webpack_public_path__ + "img/letter_foot.a31281ea.gif";